'use strict';

const { h } = require('phy');

module.exports = ({ notificationText }) => {
  return h(
    'div.select-alerts#select-notification',
    h(
      'div.notification.success',
      { style: 'display: none' },
      notificationText.success
    ),
    h(
      'div.alert.error.system',
      { style: 'display: none' },
      notificationText.failure
    )
  );
};
